module.exports = __webpack_public_path__ + "img/battery_empty.10b6d26c.svg";